
export const AUTHENTICATION = "/oAuth/Token";
export const DOCUMENT = "/api/document";
export const DOCUMENTS = "/api/documents";
export const MILESTONES = "/api/milestones";
export const SEARCH = "/api/search";
export const UPDATES = "/api/updates";
export const SCREEN_FIELDS = "/api/ScreenFields";
export const ACTIONS = "/api/actions";
export const DROPDOWNVALUES = "/api/DropdownValues";
export const SAVE_FORM_DATA = "/api/SaveFormData";
export const RECOVER_PASSWORD = "/api/Account/recoverPassword";
export const RESET_PASSWORD = "/api/Account/resetPassword";
export const TEAM = "/api/Team";
